import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Nav } from "react-bootstrap";

import DecryptData from "./DecryptData/DecryptData";
import DecryptView from "./Decrypt/Decrypt";
import UnprotectView from "./Unprotect/Unprotect";

class Decryption extends Component {
  constructor() {
    super();
    this.state = {
      type: "decrypt",
      errors: {},
    };
  }

  componentDidMount() {}

  render() {
    return (
      <div className="container" style={{ marginTop: "50px" }}>
        <Nav fill variant="tabs" defaultActiveKey="decrypt">
          <Nav.Item
            onClick={() => {
              this.setState({ type: "unprotect" });
            }}
          >
            <Nav.Link eventKey="unprotect">
              Расшифровка данных с защитой на ключ и подписью отправителя
            </Nav.Link>
          </Nav.Item>
          <Nav.Item
            onClick={() => {
              this.setState({ type: "decrypt" });
            }}
          >
            <Nav.Link eventKey="decrypt">Расшифровка данных</Nav.Link>
          </Nav.Item>
          <Nav.Item
            onClick={() => {
              this.setState({ type: "decrypt_data" });
            }}
          >
            <Nav.Link eventKey="decrypt_data">
              Расшифровка данных с защитой на ключ
            </Nav.Link>
          </Nav.Item>
        </Nav>
        <div className="sm-4" >
          {this.state.type === "decrypt_data" ? <DecryptData /> : null}
          {this.state.type === "decrypt" ? <DecryptView /> : null}
          {this.state.type === "unprotect" ? <UnprotectView /> : null}
        </div>
      </div>
    );
  }
}
export default connect()(withRouter(Decryption));
